import { render, staticRenderFns } from "./modelTemplate.vue?vue&type=template&id=67d08360&scoped=true&"
import script from "./modelTemplate.vue?vue&type=script&lang=js&"
export * from "./modelTemplate.vue?vue&type=script&lang=js&"
import style0 from "./modelTemplate.vue?vue&type=style&index=0&id=67d08360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d08360",
  null
  
)

export default component.exports